var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { connect } from '@/overmind';
import Input from 'components/Input.vue';
import { NotificationService } from '@/services/NotificationService';
let ResetPasswordContainer = class ResetPasswordContainer extends Vue {
    constructor() {
        super(...arguments);
        this.password = '';
        this.confirmPassword = '';
        this.loading = false;
        this.showPassword = false;
        this.showConfirmPassword = false;
        this.action_token = '';
        this.userName = '';
        this.userEmail = '';
    }
    mounted() {
        this.$gtag.pageview({ page_path: this.$route.path });
        const action_token = this.$route.params.token.split('=');
        this.action_token = action_token[1];
    }
    async confirm() {
        this.loading = true;
        // @ts-ignore TS2349: property inexistent
        const result = await this.actions.recoverPassword({
            action_token: this.action_token,
            password: this.password,
            password_confirmation: this.confirmPassword,
        });
        this.loading = false;
        if (result && result.status == 200) {
            this.password = '';
            this.confirmPassword = '';
            this.resetValidation();
            NotificationService.success('Sucesso', result.data.message);
            // @ts-ignore TS2349: property inexistent
            this.$auth.logout();
        }
        else {
            const errorMessage = (result && result.data && result.data.error) ||
                'Ocorreu um erro inesperado, tente novamente';
            NotificationService.error('Erro', errorMessage);
        }
    }
    resetValidation() {
        setTimeout(() => {
            // @ts-ignore TS2349: property inexistent
            if (this.$refs.new) {
                // @ts-ignore TS2349: property inexistent
                this.$refs.new.resetValidation();
            }
            // @ts-ignore TS2349: property inexistent
            if (this.$refs.confirm) {
                // @ts-ignore TS2349: property inexistent
                this.$refs.confirm.resetValidation();
            }
        }, 200);
    }
    fieldsDisabled() {
        return !(this.isPasswordValid() && this.password == this.confirmPassword);
    }
    isPasswordValid() {
        return /^(?=.*\d)(?=.*[A-Z])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{12,}$/.test(this.password);
    }
};
ResetPasswordContainer = __decorate([
    Component(connect(({ state, actions }) => ({
        state: state.users,
        actions: actions.users,
    }), {
        components: { Input },
    }))
], ResetPasswordContainer);
export default ResetPasswordContainer;
